import React from 'react';
import { Link } from 'react-router-dom'; 

const Contactbox = ({ data, varient }) => {
  return (
      <div className="container">
        <div className="row">
          {
            data.map((element, index) => (
              <div className="col-lg-4" key={index}>
            <Link to={element.link}>
                <div className={`st-iconbox st-style1 ${varient}`}>
                  <div className={`st-iconbox-icon st-${element.bg}-box`}>
                    <img src={element.icon} alt={element.icon} />
                  </div>
                  <h2 className="st-iconbox-title">{element.title}</h2>
                        <div
                            className="st-iconbox-text"
                            dangerouslySetInnerHTML={{ __html: element.subTitle }}
                        />

                </div>
                        <div className="st-height-b0 st-height-lg-b30" />

                    </Link>
              </div>
            ))
          }
          </div>
          <div className="space"></div>
          <div className="space"></div>
      </div>

  )
}

export default Contactbox;
